import { Bits } from './bits';

export enum AdsManagerPermissions {
	CanAccessAdsManager = Bits.Bit1,
	AdsManagerEdit = Bits.Bit2,
	AdsManagerDelete = Bits.Bit3,
	AdsManagerCanAccessReportsData = Bits.Bit4
}
